import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/ui/Footer';
import { Mail, Phone, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.6
  }
};
export function ContactPage() {
  return <div className="bg-black min-h-screen" data-id="element-247">
      <Header data-id="element-248" />
      <main className="pt-32 pb-24 px-6" data-id="element-249">
        <div className="max-w-4xl mx-auto" data-id="element-250">
          <motion.div className="text-center mb-16" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-251">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6" data-id="element-252">
              Get In Touch
            </h1>
            <p className="text-xl text-white/80 leading-relaxed" data-id="element-253">
              Ready to transform your healthcare data? Let's talk.
            </p>
          </motion.div>

          <motion.a href="mailto:contactus@vantagedatagroup.com" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="block bg-gradient-to-br from-purple-500/10 to-cyan-500/10 border border-white/10 rounded-3xl p-12 lg:p-16 hover:border-white/20 transition-all duration-300 mb-12" whileHover={{
          y: -8,
          scale: 1.02
        }} data-id="element-254">
            <div className="flex flex-col items-center text-center" data-id="element-255">
              <motion.div className="w-24 h-24 rounded-full bg-gradient-to-br from-purple-500 to-cyan-500 flex items-center justify-center mb-8" whileHover={{
              scale: 1.1,
              rotate: 5
            }} transition={{
              duration: 0.3
            }} data-id="element-256">
                <Mail className="w-12 h-12 text-white" data-id="element-257" />
              </motion.div>
              <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4" data-id="element-258">
                Email Us
              </h2>
              <p className="text-2xl md:text-3xl text-white/90 font-medium" data-id="element-259">
                contactus@vantagedatagroup.com
              </p>
            </div>
          </motion.a>

          
        </div>
      </main>
      <Footer data-id="element-260" />
    </div>;
}